import moment from 'moment-timezone';
import * as React from 'react';

interface LocalDateRangeProps {
  endTime?: number;
  startTime?: number;
  timeZone?: string;
}

export const LocalDateRange = ({ endTime, startTime, timeZone }: LocalDateRangeProps) => {
  if (!startTime || !endTime || !timeZone) {
    return <div>TBD</div>;
  }

  const startTimeString = moment.unix(startTime).tz(timeZone).format('h:mma');
  const endTimeString = moment.unix(endTime).tz(timeZone).format('h:mma z');
  return <div>{`${startTimeString}-${endTimeString}`}</div>;
};
